import React, { useEffect, useState, useCallback, useRef, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FacetedSearchCompact from '../Components/FacetedSearchCompact';
import { Accordion, AccordionPanel } from '../../Containers/Accordion.container';
import {
    closeDropdownMenu,
    PRODUCT_VIEW_CACHED,
    query,
    searchFacetChange, setFacetedFilters,
    submitSearchFacet,
    toggleVisibleDropdownMenu,
    updateFilterOption
} from '../../Actions/FacetedSearch.action';
import SubNav from '../../Components/SubNavCompact';
import SortCriteriaCompact from '../../Components/SortCriteriaCompact';
import { translate } from '../../Services/translation';
import FilterAnimation from "../Components/FilterAnimation";
import FilterOverlay from "../Components/FilterOverlay";

const FacetedSearchCompactContainer = function() {
    const dispatch = useDispatch();

    const facetedSearchState = useSelector(state => state.facetedSearch);
    const {
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,
        tempFilterCacheId
    } = facetedSearchState;

    const _onFacetChange = (filter, option) => {
        dispatch(setFacetedFilters(updateFilterOption(facetFilters, filter, option)));
    }

    const _query = useCallback((q, withHtmlResult) => {
        dispatch(query(q, withHtmlResult, tempFilterCacheId));
    }, [tempFilterCacheId]);

    const _onSubmit = (allFilters) => dispatch(submitSearchFacet(allFilters));
    const _toggleVisibleDropdownMenu = (group) => dispatch(toggleVisibleDropdownMenu(group));
    const _closeDropdownMenu = (group) => dispatch(closeDropdownMenu(group));
    const _searchFacetChange = (group, item) => dispatch(searchFacetChange(group, item));

    const props = {
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,

        query: _query,
        onSubmit: _onSubmit,
        onFacetChange: _onFacetChange,
        closeDropdownMenu: _closeDropdownMenu,
        searchFacetChange: _searchFacetChange,
        toggleVisibleDropdownMenu: _toggleVisibleDropdownMenu
    }

    const onSearchResultDataChange = (dom) => {
        if ([null, undefined].includes(dom)) {
            return;
        }
        const container = document.createElement('div');
        container.innerHTML = dom;
        const existingResult = document.querySelector("#search-result");
        const tempResult = container.querySelector("#search-result");
        const existingFilter = existingResult.querySelector('#facetedSearchCompact');
        const tempFilter = tempResult.querySelector('#facetedSearchCompact');
        const replace = (node, newNode) => node.parentNode.replaceChild(newNode, node);
        // move existingFilter from existingResult to tempResult
        replace(tempFilter, existingFilter);
        // replace existingResult with tempResult ( newResult )
        replace(existingResult, tempResult);
        // bootstrap react components if any exists in the search result
        window.__litium.bootstrapComponents();
    }

    const { ...facetProps } = facetedSearchState;
    const facetState = {
        ...facetProps,
        ...props,
        facetFilters,
        onFacetChange: (filter, option) => _onFacetChange(filter, option),
    };
    const empty = array => !(array && array.length);
    const subNavigations = !subNavigation ? null : [subNavigation];
    const sortCriterias = !sortCriteria || !sortCriteria.sortItems ? null : sortCriteria.sortItems;
    const hidden = [subNavigations, facetFilters, sortCriterias].every(arr => empty(arr));

    const onAnimationFinish = useCallback(() => _onSubmit(facetFilters), [facetFilters]);

    useEffect(() => {
        _query(window.location.search.substr(1) || '', false);
    }, [dispatch]);

    useEffect(() => {
        const productViewCached = window.__litium.cache ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {} : {};
        if (!productViewCached.used) {
            productViewCached.used = true;
            const dom = productViewCached.productsView;
            dom && onSearchResultDataChange(dom);
        }
    });

    return hidden ?
        null :
        <Fragment>
            <FilterOverlay />
            <FilterAnimation {...{ onAnimationFinish }} /> { /* Also does auto submit*/ }

            {navigationTheme === 'category' &&
                <div className='compact-filter category-theme'>
                    <FacetedSearchCompact {...facetState} />
                </div>
            }
        </Fragment>
}

export default FacetedSearchCompactContainer;
